import { request } from "./client";
import USE_MOCK from "../mock/config";
import {
  mockFetchTenantUsers, mockFetchTenantUser, mockCreateTenantUser,
  mockUpdateTenantUser, mockDeleteTenantUser,
} from "../mock/mockHandlers";

const tenantUsersPath = (tenantId) => `/bots/${tenantId}/users`;

export const fetchTenantUsers = (tenantId) =>
  USE_MOCK ? mockFetchTenantUsers(tenantId) : request(tenantUsersPath(tenantId));
export const fetchTenantUser = (tenantId, tenantUserId) =>
  USE_MOCK ? mockFetchTenantUser(tenantId, tenantUserId) : request(`${tenantUsersPath(tenantId)}/${tenantUserId}`);
export const bulkCreateTenantUsers = (tenantId, users) =>
  USE_MOCK ? Promise.all(users.map((u) => mockCreateTenantUser(tenantId, u))) : request(tenantUsersPath(tenantId), { method: "POST", data: users });
export const createTenantUser = (tenantId, payload) =>
  USE_MOCK ? mockCreateTenantUser(tenantId, payload) : request(tenantUsersPath(tenantId), { method: "POST", data: [payload] });
export const updateTenantUser = (tenantId, tenantUserId, payload) =>
  USE_MOCK ? mockUpdateTenantUser(tenantId, tenantUserId, payload) : request(`${tenantUsersPath(tenantId)}/${tenantUserId}`, { method: "PUT", data: payload });
export const deleteTenantUser = (tenantId, tenantUserId) =>
  USE_MOCK ? mockDeleteTenantUser(tenantId, tenantUserId) : request(`${tenantUsersPath(tenantId)}/${tenantUserId}`, { method: "DELETE" });
export const bulkDeleteTenantUsers = (tenantId, userIds) =>
  Promise.all(userIds.map((id) => deleteTenantUser(tenantId, id)));
